import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import ReactStars from 'react-stars';
import { Loading, Header, Nav, H1, Error, modalStyles } from './../../common';
import { Edit, Delete, Text } from './../../buttons';
import { MatchSquadPlayer, MatchSquadManager } from './../../layouts';
import {
	matchUpdate,
	onSeasonIdTextChange,
	onPostIdTextChange,
	onNameTextChange,
	onFormationChange,
	onActiveChange,
	onBonusTextChange,
} from './../../../actions/MatchActions';
import {
	matchSquadFetch,
	toggleEdit,
	matchSquadUpdate,
	onReviewChange,
	onGoalsChange,
	onCardsChange,
	onPositionChange,
	onRatingChange,
	addPlayerMatchSquad,
	inputPlayerChange,
	inputPositionChange,
	inputCardChange,
	inputGoalChange,
	inputMatchRatingChange,
	inputMatchReviewChange,
	deletePlayerMatchSquad,
} from './../../../actions/MatchSquadActions';
import { playerFetch } from './../../../actions/PlayerActions';
import { TextInput, Select, Checkbox } from '../../inputs';
import './MatchSquad.css';

class MatchSquad extends Component {
	constructor(props) {
		super(props);
		this.state = {
			postId: '',
			season: {
				0: { name: '2018-19', id: 0 },
				1: { name: '2019-20', id: 1 },
				2: { name: '2020-21', id: 2 },
				3: { name: '2021-22', id: 3 },
			},
			seasonById: [0, 1, 2, 3],
			season_id: 3,
			name: '',
			modal: false,
			toDelete: '',
			toDeleteId: null,
			goals: {
				0: {
					name: 0,
					id: 0,
				},
				1: {
					name: 1,
					id: 1,
				},
				2: {
					name: 2,
					id: 2,
				},
				3: {
					name: 3,
					id: 3,
				},
				4: {
					name: 4,
					id: 4,
				},
				5: {
					name: 5,
					id: 5,
				},
			},
			goalsById: [0, 1, 2, 3, 4, 5],
			cards: {
				0: {
					name: 'None',
					id: 0,
				},
				1: {
					name: 'Yellow',
					id: 1,
				},
				2: {
					id: 2,
					name: '2 Yellow',
				},
				3: {
					id: 3,
					name: 'Red',
				},
			},
			cardsById: [0, 1, 2, 3],
			formation: {
				1: {
					name: '442',
					id: 1,
					positions: [
						'gk',
						'divider',
						'rb',
						'rcb',
						'lcb',
						'lb',
						'divider',
						'rm',
						'rcm',
						'lcm',
						'lm',
						'divider',
						'rst',
						'lst',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
				2: {
					name: '352',
					id: 2,
					positions: [
						'gk',
						'divider',
						'cb1',
						'cb2',
						'cb3',
						'divider',
						'rwb',
						'rcm',
						'lcm',
						'lwb',
						'ram',
						'acm',
						'lam',
						'divider',
						'st',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
				3: {
					name: '433',
					id: 3,
					positions: [
						'gk',
						'divider',
						'rb',
						'rcb',
						'lcb',
						'lb',
						'divider',
						'rdm',
						'dm',
						'ldm',
						'rcm',
						'lcm',
						'acm',
						'divider',
						'ram',
						'lam',
						'st',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
			},
			formationById: [1, 2, 3],
			formationIndex: 0,
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleAddPlayerSubmit = this.handleAddPlayerSubmit.bind(this);
		this.matchUpdate = this.props._matchUpdate.bind(this);
		this.onSeasonIdTextChange = this.props._onSeasonIdTextChange.bind(this);
		this.onPostIdTextChange = this.props._onPostIdTextChange.bind(this);
		this.onBonusTextChange = this.props._onBonusTextChange.bind(this);
		this.onNameTextChange = this.props._onNameTextChange.bind(this);
		this.onFormationChange = this.props._onFormationChange.bind(this);
		this.onActiveChange = this.props._onActiveChange.bind(this);
		this.toggleEdit = this.props._toggleEdit.bind(this);
		this.handleModalClose = this.handleModalClose.bind(this);
		this.handleReviewChange = this.handleReviewChange.bind(this);
		this.handleGoalsChange = this.handleGoalsChange.bind(this);
		this.handleCardsChange = this.handleCardsChange.bind(this);
		this.handlePositionChange = this.handlePositionChange.bind(this);
		this.handleSquadUpdate = this.handleSquadUpdate.bind(this);
		this.handleRatingChange = this.handleRatingChange.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}
	componentWillMount() {
		this.props._playerFetch();
	}
	componentDidMount() {
		this.props._matchSquadFetch(this.props.match.params.number);
	}
	handleNewSelectPlayerChange = v =>
		this.props._inputPlayerChange(v.replace(/\s+/g, '').toLowerCase());
	handleNewSelectPositionChange = v => {
		const arr = this.state.formation[
			this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
		].positions.filter(curr => curr !== 'divider');
		this.props._inputPositionChange(arr[v]);
	};

	handleNewSelectCardChange = v => this.props._inputCardChange(this.state.cards[v].id);
	handleNewSelectGoalChange = v => this.props._inputGoalChange(v);
	handleNewRatingChange = v => this.props._inputMatchRatingChange(v);
	handleNewReviewChange = v => this.props._inputMatchReviewChange(v.target.value);
	handleSquadUpdate = obj => {
		this.props._matchSquadUpdate(parseInt(this.props.match.params.number, 10), obj);
	};
	handleReviewChange = (val, obj) => {
		this.props._onReviewChange(parseInt(this.props.match.params.number, 10), val, obj);
	};
	handlePositionChange = (val, obj) => {
		this.props._onPositionChange(parseInt(this.props.match.params.number, 10), val, obj);
	};
	handleRatingChange = (val, obj) => {
		this.props._onRatingChange(parseInt(this.props.match.params.number, 10), val, obj);
	};
	handleGoalsChange = (val, obj) => {
		this.props._onGoalsChange(parseInt(this.props.match.params.number, 10), val.toString(), obj);
	};
	handleCardsChange = (val, obj) => {
		this.props._onCardsChange(
			parseInt(this.props.match.params.number, 10),
			this.state.cards[val].name,
			obj,
		);
	};
	handlePostIdChange = v => this.setState({ post_id: v });
	handleSeasonIdChange = v => this.setState({ season_id: v });
	handleNameChange = v => this.setState({ name: v });
	handleFormatonChange = v => {
		if (v === '*Formation') {
			return this.onFormationChange(parseInt(this.props.match.params.number, 10), {
				name: this.state.formation[
					this.props.list[parseInt(this.props.match.params.number, 10)].onChange.formation_id
				].name,
				id: this.props.list[parseInt(this.props.match.params.number, 10)].onChange.formation_id,
			});
		}
		this.setState({ formationIndex: v });
		this.onFormationChange(parseInt(this.props.match.params.number, 10), {
			name: this.state.formation[parseInt(v, 10)].name,
			id: parseInt(v, 10),
		});
	};

	handleDelete() {
		this.props._deletePlayerMatchSquad(this.props.match.params.number, this.state.toDelete);
		this.setState({ modal: false, toDelete: '' });
	}

	handleModalClose() {
		this.setState({ modal: false });
	}
	handleSubmit(event) {
		event.preventDefault();
		this.props._matchUpdate(
			this.props.list[parseInt(this.props.match.params.number, 10)].onChange,
			this.props.match.params.number,
		);
	}
	handleAddPlayerSubmit = event => {
		event.preventDefault();
		if (this.props.inputPosition === ' ') return null;
		if (this.props.inputPlayer === ' ') return null;
		if (parseInt(this.props.inputMatchRating, 10) < 0) return null;
		this.props._addPlayerMatchSquad(this.props.match.params.number, this.props.inputPlayer, {
			cards: this.state.cards[this.props.inputCard].name,
			goals: parseInt(this.props.inputGoal, 10),
			matchRating: parseInt(this.props.inputMatchRating, 10),
			review: this.props.inputReview,
			position: this.props.inputPosition,
			userRating: 0,
			avgUserRating: 0,
			userRatingCount: 0,
		});
	};

	_loading() {
		if (this.props.loading) return <Loading />;
		return null;
	}

	_parseGoals = goal => {
		if (typeof goal === 'undefined') return <span />;
		if (goal === 0) return <span />;
		let gs = [];
		for (let r = 0, lenR = goal; r < goal; r++) {
			gs.push(<span key={r}>⚽</span>);
		}
		return <div>{gs}</div>;
	};

	_parseGoalValue = goal => goal;
	_parseCards = cards => {
		if (typeof cards === 'undefined') return null;
		if (cards === 'None') return null;
		if (cards === 'Yellow') return <i className="fa fa-circle yellow" />;
		if (cards === '2 Yellow')
			return (
				<div className="card-meta">
					<i className="fa fa-circle yellow first" />
					<i className="fa fa-circle yellow second" />
					<i className="fa fa-circle warningred third" />
				</div>
			);
		if (cards === 'Red') return <i className="fa fa-circle warningred" />;
	};
	_parseCardValue = cards => {
		if (cards === 'None') return 0;
		if (cards === 'Yellow') return 1;
		if (cards === '2 Yellow') return 2;
		if (cards === 'Red') return 3;
	};
	_renderList(arr) {
		let items = [];
		if (!this.props.squadList[parseInt(this.props.match.params.number, 10)]) {
			return <ul>{items}</ul>;
		}
		items = arr.map((v, i) => {
			if (v === 'divider') {
				return <li key={v + '_' + i} className="flexContainerRow section-divider" />;
			}
			if (!this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]) {
				return null;
			}
			if (
				!this.props.playerList[
					this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v].playerDoc
				]
			) {
				return null;
			}

			return (
				<li
					className="flexContainerRow matchDetail"
					key={
						this.state.formation[
							this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
						].name +
						'_' +
						v
					}>
					<div className="item box">
						{this.props.playerList[
							this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v].onChange
								.playerDoc
						].type === 'Manager' ? (
							<MatchSquadManager
								player={
									this.props.playerList[
										this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
											.playerDoc
									]
								}
								playerReport={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								}
								onTextChange={this.handleReviewChange}
								positions={this.state.formation[
									this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
								].positions.filter(curr => curr !== 'divider')}
								onPositionChange={this.handlePositionChange}
								onRatingChange={this.handleRatingChange}
								userRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.userRating
								}
								avgUserRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.avgUserRating
								}
							/>
						) : (
							<MatchSquadPlayer
								player={
									this.props.playerList[
										this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
											.playerDoc
									]
								}
								playerReport={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								}
								goals={this._parseGoals(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.goals,
								)}
								goalValue={this._parseGoalValue(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.goals,
								)}
								cards={this._parseCards(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.cards,
								)}
								cardValue={this._parseCardValue(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.cards,
								)}
								onTextChange={this.handleReviewChange}
								onGoalChange={this.handleGoalsChange}
								onCardChange={this.handleCardsChange}
								positions={this.state.formation[
									this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
								].positions.filter(curr => curr !== 'divider')}
								onPositionChange={this.handlePositionChange}
								onRatingChange={this.handleRatingChange}
								userRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.userRating
								}
								avgUserRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.avgUserRating
								}
							/>
						)}
					</div>
					<div className="small">
						<div className="flexContainerRow">
							{this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								.readOnly ? (
								<div>
									<Edit
										action={() => this.toggleEdit(parseInt(this.props.match.params.number, 10), v)}
									/>
								</div>
							) : (
								<div className="buttonText small">
									<Text
										text="Save"
										action={() =>
											this.handleSquadUpdate(
												this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
													.onChange,
											)
										}
									/>
								</div>
							)}
							{this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								.readOnly ? (
								<div>
									<Delete
										action={() =>
											this.setState({
												modal: true,
												toDelete: this.props.squadList[parseInt(this.props.match.params.number, 10)]
													.squad[v].playerDoc,
												toDeleteId: v,
											})
										}
									/>
								</div>
							) : (
								<div className="buttonText">
									<Text
										text="Cancel"
										action={() => this.toggleEdit(parseInt(this.props.match.params.number, 10), v)}
									/>
								</div>
							)}
							{this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v].error ? (
								<Error
									text={
										this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
											.errorText
									}
								/>
							) : null}
						</div>
					</div>
				</li>
			);
		});
		return <ul>{items}</ul>;
	}
	render() {
		if (this.props.loading) return <Loading />;
		if (this.props.squadLoading) return <Loading />;
		if (this.props.playerLoading) return <Loading />;
		if (!this.props.list) return <Loading />;
		if (!this.props.list[parseInt(this.props.match.params.number, 10)]) return <Loading />; //if (!this.props.squadList[parseInt(this.props.match.params.number, 10)]) return <Loading />;
		return (
			<div>
				<Header />
				<div className="container">
					<Nav />
					<div className="match matchAdmin">
						<H1 text={this.props.list[parseInt(this.props.match.params.number, 10)].title} />
						<div className="section admin flexContainerRow forms">
							<div className="item">
								<p>Edit Match</p>
								<form>
									<div className="flexContainerRow">
										<div className="item small">
											<div className="fullWidth">
												<TextInput
													inputId={'matchpost_id'}
													placeholder="*Post Id"
													label={'Post Id'}
													value={
														this.props.list[parseInt(this.props.match.params.number, 10)].onChange
															.postId
													}
													onTextChange={val =>
														this.onPostIdTextChange(
															parseInt(this.props.match.params.number, 10),
															val,
														)
													}
												/>
											</div>
										</div>
										<div className="item small">
											<label>
												Season
												<Select
													currentVal={this.state.season_id}
													options={this.state.season}
													optionsById={this.state.seasonById}
													onChange={val =>
														this.onSeasonIdTextChange(
															parseInt(this.props.match.params.number, 10),
															parseInt(val, 10),
														)
													}
												/>
											</label>
										</div>
									</div>
									<div className="flexContainerRow">
										<div className="item">
											<div className="fullWidth">
												<TextInput
													inputId={'matchname'}
													placeholder="*Title"
													label={'Title'}
													value={
														this.props.list[parseInt(this.props.match.params.number, 10)].onChange
															.title
													}
													onTextChange={val =>
														this.onNameTextChange(parseInt(this.props.match.params.number, 10), val)
													}
												/>
											</div>
										</div>
									</div>
									<div className="flexContainerRow">
										<div className="item small">
											<label>
												Formation
												<Select
													currentVal={
														this.props.list[parseInt(this.props.match.params.number, 10)].onChange
															.formation_id
													}
													options={this.state.formation}
													optionsById={this.state.formationById}
													onChange={this.handleFormatonChange}
												/>
											</label>
										</div>
									</div>
									<div className="flexContainerRow">
										<label>
											Bonus rating
											<div className="item">
												<textarea
													rows="4"
													cols="50"
													value={
														this.props.list[parseInt(this.props.match.params.number, 10)].onChange
															.bonus
													}
													onChange={v =>
														this.onBonusTextChange(
															parseInt(this.props.match.params.number, 10),
															v.target.value,
														)
													}
												/>
											</div>
										</label>
									</div>
									<div className="flexContainerRow">
										<div className="item">
											<div className="buttonText">
												<Text text="Update match" action={this.handleSubmit} />
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="item">
								<p>Add a player</p>
								<form>
									<div className="flexContainerRow">
										<div className="item">
											<label>
												*Select a player
												<Select
													matchSquad
													prompt={' '}
													currentVal={this.props.inputPlayer}
													options={this.props.playerList}
													optionsById={this.props.playerListById}
													onChange={this.handleNewSelectPlayerChange}
												/>
											</label>
										</div>
									</div>
									<div className="flexContainerRow">
										<div className="item small">
											<label>
												*Set position
												<Select
													prompt={' '}
													currentVal={this.state.formation[
														this.props.list[parseInt(this.props.match.params.number, 10)]
															.formation_id
													].positions
														.filter(curr => curr !== 'divider')
														.indexOf(this.props.inputPosition)}
													options={this.state.formation[
														this.props.list[parseInt(this.props.match.params.number, 10)]
															.formation_id
													].positions
														.filter(curr => curr !== 'divider')
														.reduce((acc, elem, ind) => {
															acc[ind] = {
																id: ind,
																name: elem.toUpperCase(),
															};
															return acc;
														}, {})}
													optionsById={Array.from(
														{
															length: this.state.formation[
																this.props.list[parseInt(this.props.match.params.number, 10)]
																	.formation_id
															].positions.filter(curr => curr !== 'divider').length,
														},
														(v, i) => i,
													)}
													onChange={this.handleNewSelectPositionChange}
												/>
											</label>
										</div>
										<div className="item small">
											<label>
												Cards
												<Select
													currentVal={this.state.cards[this.props.inputCard].id}
													options={this.state.cards}
													optionsById={this.state.cardsById}
													onChange={this.handleNewSelectCardChange}
												/>
											</label>
										</div>
										<div className="item small">
											<label>
												Goals
												<Select
													currentVal={this.props.inputGoal}
													options={this.state.goals}
													optionsById={this.state.goalsById}
													onChange={this.handleNewSelectGoalChange}
												/>
											</label>
										</div>
									</div>
									<div className="flexContainerRow">
										<div className="item">
											<ReactStars
												count={10}
												onChange={this.handleNewRatingChange}
												size={20}
												value={this.props.inputMatchRating}
												color1={'#C5C5C5'}
												color2={'#ffc000'}
											/>
										</div>
									</div>
									<div className="flexContainerRow">
										<div className="item">
											<textarea
												rows="4"
												cols="50"
												value={this.props.inputReview}
												onChange={this.handleNewReviewChange}
											/>
										</div>
									</div>
									<div className="item small">
										<div className="buttonText">
											<Text text="Add player" action={this.handleAddPlayerSubmit} />
										</div>
									</div>
								</form>
							</div>
						</div>
						<p>Match day squad 💪 *Layout changes based on formation above ⬆️ </p>
						<p>Copy this <a target='_blank' href={'/match/' + this.state.season_id + '/' + parseInt(this.props.match.params.number, 10)}>Match link to share</a></p>
						{this._renderList(
							this.state.formation[
								this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
							].positions,
						)}
						<div className="section-divider" />
						<div className="item" />
					</div>
				</div>
				<ReactModal
					isOpen={this.state.modal}
					onRequestClose={this.handleModalClose}
					style={modalStyles}
					ariaHideApp={false}
					contentLabel="Confirm">
					<h2 style={{ textAlign: 'center' }}>Delete {this.state.toDelete} from squad?</h2>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div style={{ flex: 1 }}>
							<Text text="Delete" action={this.handleDelete} />
						</div>
						<div style={{ flex: 1 }}>
							<Text text="Cancel" action={this.handleModalClose} />
						</div>
					</div>
				</ReactModal>
			</div>
		);
	}
}
const mapStateToProps = ({ match, matchSquad, player }) => {
	const { loading, errorText, list } = match;
	return {
		squadList: matchSquad.list,
		squadLoading: matchSquad.loading,
		squadErrorText: matchSquad.errorText,
		inputPlayer: matchSquad.inputPlayer,
		inputPosition: matchSquad.inputPosition,
		inputGoal: matchSquad.inputGoal,
		inputCard: matchSquad.inputCard,
		inputMatchRating: matchSquad.inputMatchRating,
		inputReview: matchSquad.inputReview,
		inputLoading: matchSquad.inputLoading,
		playerLoading: player.loading,
		playerList: player.list,
		playerListById: player.listByID,
		loading,
		errorText,
		list,
	};
};
const mapDispatchToProps = dispatch => ({
	_addPlayerMatchSquad: (doc, playerDoc, obj) => dispatch(addPlayerMatchSquad(doc, playerDoc, obj)),
	_matchUpdate: (obj, doc) => dispatch(matchUpdate(obj, doc)),
	_matchSquadUpdate: (id, obj) => dispatch(matchSquadUpdate(id, obj)),
	_onPositionChange: (id, val, obj) => dispatch(onPositionChange(id, val, obj)),
	_onReviewChange: (id, text, obj) => dispatch(onReviewChange(id, text, obj)),
	_onRatingChange: (id, val, obj) => dispatch(onRatingChange(id, val, obj)),
	_onGoalsChange: (id, val, obj) => dispatch(onGoalsChange(id, val, obj)),
	_onCardsChange: (id, val, obj) => dispatch(onCardsChange(id, val, obj)),
	_playerFetch: () => dispatch(playerFetch()),
	_matchSquadFetch: id => dispatch(matchSquadFetch(id)),
	_toggleEdit: (id, pos) => dispatch(toggleEdit(id, pos)),
	_onSeasonIdTextChange: (id, text) => dispatch(onSeasonIdTextChange(id, text)),
	_onPostIdTextChange: (id, text) => dispatch(onPostIdTextChange(id, text)),
	_onNameTextChange: (id, text) => dispatch(onNameTextChange(id, text)),
	_onFormationChange: (id, obj) => dispatch(onFormationChange(id, obj)),
	_onActiveChange: (id, text) => dispatch(onActiveChange(id, text)),
	_inputPlayerChange: v => dispatch(inputPlayerChange(v)),
	_inputPositionChange: v => dispatch(inputPositionChange(v)),
	_inputCardChange: v => dispatch(inputCardChange(v)),
	_inputGoalChange: v => dispatch(inputGoalChange(v)),
	_inputMatchRatingChange: v => dispatch(inputMatchRatingChange(v)),
	_inputMatchReviewChange: v => dispatch(inputMatchReviewChange(v)),
	_deletePlayerMatchSquad: (doc, playerDoc) => dispatch(deletePlayerMatchSquad(doc, playerDoc)),
	_onBonusTextChange: (id, text) => dispatch(onBonusTextChange(id, text)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MatchSquad);



// WEBPACK FOOTER //
// ./src/components/screens/matchSquad/MatchSquad.js